import { AuthProvider } from './../../providers/auth/auth';
import { TasksPage } from './../tasks/tasks';
import { Component } from '@angular/core';
import { NavController, LoadingController, AlertController } from 'ionic-angular';
import { HttpErrorResponse } from '@angular/common/http';
import { UtilsProvider } from '../../providers/utils/utils';

@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage {
  public username: string;
  public password: string;
  public authcode: string;
  private loader: any;
  public logingIn: boolean = false;
  public isAdmin: boolean = false;
  public isReset: boolean = false;
  public isReVerify: boolean = false;
  public showLoginScreen: boolean = false;

  constructor(
    public navCtrl: NavController,
    public authProvider: AuthProvider,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    private utilsProvider: UtilsProvider
  ) {
    this.utilsProvider.checkVersion();
  }

  ionViewDidLoadw() {
    // this.presentLoading();
    this.username = 'lite@mailinator.com'
    this.password = 'installer@lite'
    this.login();
  }
  // bu() {
  ionViewDidLoad() {
    // this.presentLoading();
    // return
    this.authProvider.checkUser().subscribe(
      data => {
        console.log('data',data);
        if (data && !data.showLoginScreen) {
          this.authProvider.registerFCM().subscribe(
            r => {
              // this should not stop if registering the FCM fails
              console.log('Success on FCM register', r);
            },
            e => {
              // debug error
              console.log('Error on FCM register: ', e);
            }
          );
          this.navCtrl.setRoot(TasksPage, {
            animate: true,
            direction: 'forward'
          });
        } else if (data && data.showLoginScreen){
          this.showLoginScreen = true;
          if(this.loader) this.loader.dismiss();
          console.log('this.login()');
          // this.login();
        }
      },
      errorResult => {
        this.showLoginScreen = true;
        if(errorResult.error){
          let  message;
          if(!errorResult.error.message){
            message = 'Failed to login, please check your details and try again.';
          } else if (errorResult.error.message.includes('jwt expired')){
            message = 'Failed to login, this link has expired.';
          }
          if(message){
            let alert = this.alertCtrl.create({
              title: 'Error!',
              message: message,
              buttons: ['OK']
            });
            alert.present();
          }
        }
        if(this.loader) this.loader.dismiss();
      },
      () => {
        if(this.loader) this.loader.dismiss();
      }
    );
  }
  presentLoading() {
    this.loader = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loader.present();
  }

  resendVerification(){
    this.authProvider.verificationResend(this.username).subscribe(
      data => {

        let message = 'An email was sent to, ' + this.username + ', to reverify your account.';
        let alert = this.alertCtrl.create({
          title: 'Reverify Email',
          message: message,
          buttons: ['OK']
        });
        alert.present();
        this.resetToLogin()
      },
      (error: HttpErrorResponse) => {

        let message = error.error && error.error.message ? error.error.message : 'other message';//error.message ? error.message : 'Failed to reverify, please check your details and try again.';
        let alert = this.alertCtrl.create({
          title: 'Error!',
          message: message,
          buttons: ['OK']
        });
        alert.present();
      }
    );


  }
  resetToLogin(){
    this.isReVerify = false;
    this.isReset = false;
  }
  forgotPassword() {
    this.logingIn = true;
    this.authProvider.forgotPassword(this.username).subscribe(
      data => {
        //this.navCtrl.setRoot(Tasks, { animate: true, direction: 'forward' });
        let message = 'An email was sent to, ' + this.username + ', to assist in resetting your password.';
        let alert = this.alertCtrl.create({
          title: 'Forgot password',
          message: message,
          buttons: ['OK']
        });
        alert.present();
      },
      error => {
        let message = error.message ? error.message : 'Failed to reset password, please check your details and try again.';
        let alert = this.alertCtrl.create({
          title: 'Error!',
          message: message,
          buttons: ['OK']
        });
        alert.present();
      }
    );
  }

  login() {
    this.logingIn = true;
    this.authProvider.loginUser(this.username, this.password, this.authcode).subscribe(
      data => {

        this.authProvider.registerFCM().subscribe(
          r => {
            // this should not stop if registering the FCM fails
            console.log('Success on FCM register', r);
          },
          e => {
            // debug error
            console.log('Error on FCM register: ', e);
          }
        );

        this.navCtrl.setRoot(TasksPage, {
          animate: true,
          direction: 'forward'
        });
      },
      (errorResult: HttpErrorResponse) => {

        if (errorResult.error && errorResult.error.error === '2fa_required') {
          // this.isAdmin = true;
          // let message = 'Enter your two factor authentication';
          // let alert = this.alertCtrl.create({
          //   title: 'Authentication',
          //   message: message,
          //   buttons: ['OK']
          // });
          // alert.present();
          this.authcode = '1';
          this.login();
        } else {
          let message =
            errorResult.error && errorResult.error
              ? errorResult.error.message
              : 'Failed to login, please check your details and try again.';

          if (errorResult.status === 0) message = 'No internet connection found.';
          let alert = this.alertCtrl.create({
            title: 'Error!',
            message: message,
            buttons: ['OK']
          });
          alert.present();
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts